import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AddPopupComponent } from '../Popups/add-popup/add-popup.component';
import { AddJobPositionComponent } from '../Popups/add-job-position/add-job-position.component';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { OrganizationService } from '../../shared/services/organization.service';
import { DeletePopupComponent } from '../Popups/delete-popup/delete-popup.component'
import { Sort } from '@angular/material';
import { ToastService } from '../../shared/services/toast.service';

@Component({
    selector: 'app-inner-heirarchy',
    templateUrl: './inner-heirarchy.component.html',
    styleUrls: ['./inner-heirarchy.component.css']
})
export class InnerHeirarchyComponent implements OnInit {
    @Input() isGraphic;
    public hrManagerFilter: Boolean = true;
    public functionalManagerFilter: Boolean = false;
    public lineManagerFilter: Boolean = false;
    public managerFilter;
    // ACL for filters
    public organizationId: string;
    public organization: any;
    public associates = [];
    public graphicalOrTabuler = 'tabular';
    public organizationIdsArray = [];
    constructor(public dialog: MatDialog,
        public mobileNav: MobileNavService,
        public organizationService: OrganizationService,
        public route: ActivatedRoute,
        public router: Router,
        public toastService: ToastService) { }

    openDialog(mode: string, index?: number): void {
        const dialogRef = this.dialog.open(AddJobPositionComponent, {
            width: '450px',
            data: {
                'organogram': this.organization.organogram,
                'mode': mode, i: index
            }
        });

        if (mode === 'Add') {
            dialogRef.afterClosed().subscribe(result => {
                if (result !== 'Cancel') {
                    let position = {
                        'position': result.position,
                        'level': '',
                        'reportingTo': result.reportingTo,
                        'active': true
                    };
                    this.organization.organogram.push(position);
                    this.calculateInternalHeirarchy();
                    this.update();
                }
            });
        } else if (mode === 'Edit') {
            dialogRef.afterClosed().subscribe(result => {
                if (result !== 'Cancel') {
                    let position = {
                        'position': result.position,
                        'level': '',
                        'reportingTo': result.reportingTo,
                        'active': true
                    };
                    let posParent = {};
                    let posLevel = {};
                    this.organization.organogram.forEach(pos => {
                        posParent[pos.position] = pos.reportingTo;
                        posLevel[pos.position] = null;
                    });
                    let updatePermission = true;
                    let tempReportingToPosition = result.reportingTo;
                    let currentPositionName = result.position;
                    while (tempReportingToPosition !== '') {
                        if (tempReportingToPosition === currentPositionName) {
                            updatePermission = false;
                            break;
                        } tempReportingToPosition = posParent[tempReportingToPosition];
                    }
                    if (updatePermission) {
                        this.organization.organogram[index] = position;
                        this.calculateInternalHeirarchy();
                        this.update();
                    } else {
                        this.toastService.error(`Error while updating Hierarchy, "${result.reportingTo}" is child position of "${result.position}"`);
                    }
                }
            });
        }
    }

    deletePosition(index: number) {
        const dialogRefDelete = this.dialog.open(DeletePopupComponent, {
            width: '450px',
            data: { name: 'Position' }
        });
        dialogRefDelete.afterClosed().subscribe(result => {
            if (result === 'Cancel') {
            } else if (result === 'Proceed') {
                let tempObj: any = this.organization.organogram[index];
                this.organization.organogram = this.organization.organogram.filter(pos => pos !== tempObj);
                this.calculateInternalHeirarchy();
                this.update();
            }
        });
    }
    onClickMe() {
        this.mobileNav.showSideNav();
    }
    getAssociates(orgId) {
        if (orgId) {
            this.organizationService.getOpcoAssociatesHeirarchy(orgId).subscribe(data => {
                this.associates = Object.assign([], data);
            }, error => { });
        }
    }
    ngOnInit() {
       
        if (this.isGraphic === 'true') {
            this.graphicalOrTabuler = "graphical";
        } else if (this.isGraphic === 'false') {
            this.graphicalOrTabuler = "tabular";
        }
        // this.functionalManagerFilter = false;
        // this.hrManagerFilter = true;
        // this.lineManagerFilter = false;
        this.route.params.subscribe(params => {
            this.organizationId = params['org-id'];
            //this.getAssociates(this.organizationId);
        });
        this.organization = Object.assign({}, this.route.snapshot.data['organization']['data'][0]);
        // console.log('Organization Name', this.organization.company.companyName);
        this.organizationIdsArray.push(this.organization._id);
        this.organizationService.getOpcoAssociatesHeirarchy(this.organization._id).subscribe(data => {
            this.associates = Object.assign([], data);
        }, error => { });
    }

    update() {
        this.organizationService.updateOrganization(this.organization).subscribe((data) => {
        }, (error) => { });
    }

    calculateInternalHeirarchy() {
        // calculating heirarchy for internal positions
        let tempArr = this.organization.organogram;
        let posParent = {};
        let posLevel = {};
        tempArr.forEach(pos => {
            posParent[pos.position] = pos.reportingTo;
            posLevel[pos.position] = null;
        });
        for (let pos in posLevel) {
            if (posLevel.hasOwnProperty(pos)) {
                if (posParent[pos] === '') {
                    posLevel[pos] = 1;
                }
            }
        }
        for (let i = 0; i < 50; i++) {
            for (let pos in posLevel) {
                if (posLevel.hasOwnProperty(pos)) {
                    if (posLevel[pos] != null) {
                        for (let posP in posParent) {
                            if (posParent.hasOwnProperty(posP)) {
                                if (posParent[posP] === pos) {
                                    posLevel[posP] = posLevel[pos] + 1;
                                }
                            }
                        }
                    }
                }
            }
        }
        this.organization.organogram.forEach(element => {
            element.level = posLevel[element.position];
        });
    }



    sortData(sort: Sort) {
        const data = this.organization.organogram.slice();
        if (!sort.active || sort.direction == '') {
            this.organization.organogram = data;
            return;
        }

        this.organization.organogram = data.sort((a, b) => {
            let isAsc = sort.direction == 'asc';
            switch (sort.active) {
                case 'position': return this.compare(a.position, b.position, isAsc);
                case 'level': return this.compare(a.level, b.level, isAsc);
                case 'reportingTo': return this.compare(a.reportingTo, b.reportingTo, isAsc);
                case 'personalInformation.fullName': return this.compare(a.personalInformation.fullName, b.personalInformation.fullName, isAsc);
                case 'jobDescription.functionalManager.name': return this.compare(a.jobDescription.functionalManager.name, b.jobDescription.functionalManager.name, isAsc);
                case 'jobDescription.hrManager.name': return this.compare(a.jobDescription.hrManager.name, b.jobDescription.hrManager.name, isAsc);
                case 'jobDescription.manager.name': return this.compare(a.jobDescription.manager.name, b.jobDescription.manager.name, isAsc);
                
                default: return 0;
            }
        });
    }
    compare(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    onChange() {
        if (this.managerFilter === 'functional') {
            this.functionalManagerFilter = true;
            this.hrManagerFilter = false;
            this.lineManagerFilter = false;
        } else if (this.managerFilter === 'hr') {
            this.functionalManagerFilter = false;
            this.hrManagerFilter = true;
            this.lineManagerFilter = false;
        } else if (this.managerFilter === 'line') {
            this.functionalManagerFilter = false;
            this.hrManagerFilter = false;
            this.lineManagerFilter = true;
        } else if (this.managerFilter === 'all') {
            this.functionalManagerFilter = true;
            this.hrManagerFilter = true;
            this.lineManagerFilter = true;
        }
    }

    
}
